module.exports = __webpack_public_path__ + "img/kefu-photo.0252752a.png";